
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { app } from "../firebase/firebase";

const db = getFirestore(app);

const Dashboard = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate("/contactlist");
  };

  // Fetch total users from Firestore
  useEffect(() => {
    const fetchTotalUsers = async () => {
      const snapshot = await getDocs(collection(db, "contact"));
      setTotalUsers(snapshot.size);
    };

    fetchTotalUsers();
  }, []);

  return (
    <div className="container px-6 py-6">
      <h1 className="text-4xl font-semibold mt-14 text-blue-600">Dashboard</h1>
      <div
        onClick={handleCardClick}
        className="mt-8  bg-[#e8eff8] rounded-lg h-44 w-72 shadow-xl shadow-blue-300 cursor-pointer  text-center hover:bg-white transition duration-300"
      >
        <h3 className="text-3xl pt-10 font-semibold text-blue-700 ">
          Contact List
        </h3>
        <h2 className=" pt-8 text-lg  font-semibold text-blue-600">
          Total Users: {totalUsers}
        </h2>
        <p className="text-gray-600 text-sm ">
          Click here to view the contact list
        </p>
      </div>
    </div>
  );
};

export default Dashboard;
